(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ct-purezing-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-pdp-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      gallery.querySelectorAll('[data-pdp-target]').forEach(button => {
        button.addEventListener('click', () => {
          gallery.querySelectorAll('[data-pdp-slide]').forEach(slide => {
            slide.hidden = slide.id !== button.getAttribute('aria-controls');
            if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause());
          });
          gallery.querySelectorAll('[data-pdp-target]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
    });
    root.querySelectorAll('.ct-pdp').forEach(section => {
      const sticky = section.querySelector('[data-pdp-sticky]');
      const offer = section.querySelector('#pdp-offer');
      if (!sticky || !offer || sticky.dataset.ready) return;
      sticky.dataset.ready = 'true';
      new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, {threshold: .25}).observe(offer);
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ct-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ct-proof-carousel')) {
 customElements.define('ct-proof-carousel', class extends HTMLElement {
  connectedCallback() {
   if (this.connected) return;
   this.connected = true;
   this.dataset.ready = "true";
   this.cleanups = [];
   ['images'].forEach(kind => {
    const track = this.querySelector('.ct-proof__mosaic');
    const controls = this.querySelector('[data-controls="' + kind + '"]');
    if (!track || !controls) return;
    controls.hidden = false;
    const prev = controls.querySelector('[data-step="-1"]');
    const next = controls.querySelector('[data-step="1"]');
    const stepSize = () => (track.children[0]?.getBoundingClientRect().width || track.clientWidth) + parseFloat(getComputedStyle(track).gap || 0);
    const update = () => {
     prev.disabled = track.scrollLeft < 2;
     next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
     const position = controls.querySelector('[data-position]');
     if (position) position.textContent = (Math.round(track.scrollLeft / stepSize()) + 1) + ' / ' + track.children.length;
    };
    const click = event => {
     const button = event.target.closest('button[data-step]');
     if (!button) return;
     track.scrollBy({left:Number(button.dataset.step) * stepSize(),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    controls.addEventListener('click',click);track.addEventListener('scroll',update,{passive:true});
    const resize = new ResizeObserver(update);resize.observe(track);update();
    this.cleanups.push(() => {controls.removeEventListener('click',click);track.removeEventListener('scroll',update);resize.disconnect();});
   });
  }
  disconnectedCallback(){this.cleanups?.forEach(fn=>fn());this.connected=false;}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ct-video-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ct-video-carousel')){
  customElements.define('ct-video-carousel',class extends HTMLElement{
    connectedCallback(){
      this.abortController=new AbortController();
      const options={signal:this.abortController.signal};
      const track=this.querySelector('.ct-videos__track');
      const videos=[...this.querySelectorAll('video')];
      const buttons=[...this.querySelectorAll('[data-direction]')];
      const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      const update=()=>{buttons[0].disabled=track.scrollLeft<2;buttons[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;};
      const move=direction=>{const card=track.querySelector('article');if(card)track.scrollBy({left:direction*(card.getBoundingClientRect().width+16),behavior:reduced.matches?'instant':'smooth'});};
      buttons.forEach(button=>button.addEventListener('click',()=>move(Number(button.dataset.direction)),options));
      track.addEventListener('scroll',update,{...options,passive:true});
      track.addEventListener('keydown',event=>{if(event.target!==track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}},options);
      videos.forEach(video=>video.addEventListener('play',()=>videos.forEach(other=>{if(other!==video)other.pause();}),options));
      this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)entry.target.pause();}),{threshold:.25});
      videos.forEach(video=>this.observer.observe(video));
      document.addEventListener('visibilitychange',()=>{if(document.hidden)videos.forEach(video=>video.pause());},options);
      this.resizeObserver=new ResizeObserver(update);this.resizeObserver.observe(track);update();
    }
    disconnectedCallback(){this.abortController?.abort();this.observer?.disconnect();this.resizeObserver?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nervo-lifestyle"] && !Shopify.designMode) return;
  try {
    
const setupNervoLifestyle=()=>document.querySelectorAll('.nervo-lifestyle').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const track=root.querySelector('.nervo-lifestyle__track');const buttons=root.querySelectorAll('[data-direction]');const sync=()=>{buttons[0].disabled=track.scrollLeft<2;buttons[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};buttons.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.direction)*(track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));track.addEventListener('scroll',sync,{passive:true});new ResizeObserver(sync).observe(track);sync();});setupNervoLifestyle();document.addEventListener('shopify:section:load',setupNervoLifestyle);

  } catch(e) { console.error(e); }
})();
})();
